import dayjs from 'dayjs';
export const getTimeFormatFromDate = (date) => {
    const dateMoment = dayjs(date);
    return `${dateMoment.format('HH:mm')}`;
};
